import { render, staticRenderFns } from "./editPayway.vue?vue&type=template&id=aa74dc42&"
import script from "./editPayway.vue?vue&type=script&lang=js&"
export * from "./editPayway.vue?vue&type=script&lang=js&"
import style0 from "./editPayway.vue?vue&type=style&index=0&id=aa74dc42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports